import isObject from 'lodash/isObject';
import type { SizeAndClassType } from 'types';

type WithSizeAndClass = { sizeAndClass?: SizeAndClassType };

export const SIZE_AND_CLASS_CONFIG = [
  ['size', 'size'],
  ['unit', 'unit'],
  ['class', 'classType'],
];

function hasSizeAndClass(data: object): data is WithSizeAndClass {
  return 'sizeAndClass' in data;
}

/** Legacy procedures stored sizeAndClass on annotation.data, not the work step. */
export function getSizeAndClassFromAnnotationData(
  annotationData: unknown
): SizeAndClassType | undefined {
  if (!isObject(annotationData) || !hasSizeAndClass(annotationData)) {
    return undefined;
  }
  return annotationData.sizeAndClass
    ? { ...annotationData.sizeAndClass }
    : undefined;
}

/** Drop sizeAndClass from annotation.data so shared hotspots stay per-workstep. */
export function withoutSizeAndClass<T extends object>(
  data: T
): Omit<T, 'sizeAndClass'> {
  if (!hasSizeAndClass(data)) {
    return data;
  }
  const { sizeAndClass: _removed, ...rest } = data;
  return rest;
}
